import React from 'react'

interface SizedIconProps {
  size?: number
}

export const BuildingIcon = ({ size = 18 }: SizedIconProps = {}): React.ReactElement => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.375 3.125C4.02982 3.125 3.75 3.40482 3.75 3.75V16.875H2.5V18.125H17.5V16.875H16.25V8.75C16.25 8.40482 15.9702 8.125 15.625 8.125H12.5V3.75C12.5 3.40482 12.2202 3.125 11.875 3.125H4.375ZM11.25 16.875V4.375H5V16.875H6.875V14.375H9.375V16.875H11.25ZM12.5 16.875H15V9.375H12.5V16.875ZM6.25 6.25H7.5V7.5H6.25V6.25ZM10 6.25H8.75V7.5H10V6.25ZM6.25 9.375H7.5V10.625H6.25V9.375ZM10 9.375H8.75V10.625H10V9.375ZM6.25 12.5H7.5V13.75H6.25V12.5ZM10 12.5H8.75V13.75H10V12.5ZM13.125 10.625H14.375V11.875H13.125V10.625ZM14.375 13.125H13.125V14.375H14.375V13.125Z'
      fill='currentColor'
    />
  </svg>
)

export const TeamsIcon = ({ size = 18 }: SizedIconProps = {}): React.ReactElement => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
    <path
      d='M7 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.5c-3 0-5.5 1.5-5.5 4V17h11v-1.5c0-2.5-2.5-4-5.5-4Zm7-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm4.5 5.5v.5h-4.2c.13-.47.2-.97.2-1.5 0-.89-.22-1.72-.62-2.45.35-.04.71-.05 1.12-.05 2.5 0 3.5 1.5 3.5 3.5Z'
      fill='currentColor'
    />
  </svg>
)

export const UserSilhouetteIcon = (): React.ReactElement => (
  <svg viewBox='0 0 24 24' fill='none'>
    <path
      d='M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5Z'
      fill='currentColor'
    />
  </svg>
)

export const PeopleGroupIcon = ({ size = 16 }: SizedIconProps = {}): React.ReactElement => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
    <path
      fill='currentColor'
      d='M7 9a3 3 0 100-6 3 3 0 000 6zm7 0a3 3 0 100-6 3 3 0 000 6zM1 16c0-3 3-5 6-5s6 2 6 5v1H1v-1zm12 1v-1c0-1.7-.9-3.2-2.3-4.2C11.5 11.3 12.7 11 14 11c3 0 6 2 6 5v1h-7z'
    />
  </svg>
)
